import { Reducer } from "redux";
import { VisibleCompanyDataModel } from "../../common/models/CommonModels";
import { ResourceLoadingState, CachedFiltersState } from "../../common/store/stateHelpers";
import { FilterInfo } from "../../common/models/CommonModels";

export enum ActionType {
    RequestVisibleCompanies = "COMPANIES/REQUEST_VISIBLE_COMPANIES",
    ReceivedVisibleCompanies = "COMPANIES/RECEIVED_VISIBLE_COMPANIES",
    CacheFilters = "COMPANIES/CACHE_FILTERS"
}

export interface RequestVisibleCompaniesAction {
    type: ActionType.RequestVisibleCompanies,
}

interface ReceivedVisibleCompaniesAction {
    type: ActionType.ReceivedVisibleCompanies,
    data: VisibleCompanyDataModel[]
}

interface CacheFiltersAction {
    type: ActionType.CacheFilters,
    filters: FilterInfo
}

export type CompanyAction = RequestVisibleCompaniesAction
    | ReceivedVisibleCompaniesAction
    | CacheFiltersAction;

export const actionCreators = {
    requestVisibleCompanies: (filters?: FilterInfo) => <RequestVisibleCompaniesAction>{ type: ActionType.RequestVisibleCompanies, filters },
    receivedVisibleCompanies: (data: VisibleCompanyDataModel[]) => <ReceivedVisibleCompaniesAction>{ type: ActionType.ReceivedVisibleCompanies, data },
    cacheFilters: (filters: FilterInfo) => <CacheFiltersAction>{ type: ActionType.CacheFilters, filters }
}

export type CompanyState = ResourceLoadingState<VisibleCompanyDataModel> &
                            CachedFiltersState;

const initialState: CompanyState = {
    isLoading: false,
    filters: undefined,
    data: []
}

export const reducer: Reducer<CompanyState> = (state: CompanyState, action: CompanyAction) => {
    switch (action.type) {
        case ActionType.RequestVisibleCompanies:
            return {    
                ...state,
                isLoading: true,
                data: []
            }
        case ActionType.ReceivedVisibleCompanies:
            return {
                ...state,
                isLoading: false,
                data: action.data
            }
        case ActionType.CacheFilters:
            return {
                ...state,
                filters: action.filters
            }
        default:
            const exhaustiveCheck: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/companies/store/companyStore.ts